import { alpha, Stack, styled } from "@mui/material";

export const LandingCard = styled(Stack)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.white, 0.75),
  maxWidth: "1000px",
  width: "100%",
  rowGap: "44px",
  alignItems: "center",
  boxShadow: "0px 4px 75px 0px rgba(112, 222, 255, 0.32)",
  borderRadius: "40px",
  backdropFilter: "blur(5px)",

  [theme.breakpoints.down("tablet")]: {
    borderRadius: "20px",
  },
}));
